import React, { useState } from 'react';
import {
  Badge,
  Button,
  Icon,
  InputAdornment,
  FormHelperText,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';
import ViewColumn from 'helpers/ViewColumn';
import { useStyles } from './styles';


const DepositsTableToolbar = (
  {
    onSearch,
    setOpenFilter,
    filterConditions,
    tableCells,
    setHeadTableCells
  }: ICustomToolbar
) => {
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState('');
  const [searchField, setSearchField] = useState('order_id');
  const selectedConditions = Object.values(filterConditions).filter((condition) => !!condition?.value.length);

  return (
    <Toolbar className="w-full relative">
      <div className="flex-column w-full">
        <div className="flex items-center w-full">
          <TextField
            variant="outlined"
            className={`w-full max-w-300 text-primary ${classes.bgBlue} ${classes.customSearch}`}
            name="search-orders-value"
            placeholder="Search"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                onSearch(searchValue, searchField);
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {!searchValue.length ?
                    <Icon color="primary">search</Icon>
                    :
                    <Icon
                      color="primary"
                      className="cursor-pointer"
                      onClick={() => {
                        setSearchValue(() => '');
                        onSearch('', 'name');
                      }}
                    >
                      close
                    </Icon>
                  }
                </InputAdornment>
              ),
            }}
          />
          <TextField
            select
            variant="outlined"
            className={`w-full max-w-200 mr-3 text-primary ${classes.bgBlue} ${classes.customSearchField}`}
            name="search-orders-field"
            value={searchField}
            onChange={(event) => {
              setSearchField(event.target.value);

              if (searchValue) {
                onSearch(searchValue, event.target.value);
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">by</InputAdornment>
              )
            }}
          >
            <MenuItem value="order_id">Order ID</MenuItem>
            <MenuItem value="email">Customer Email</MenuItem>
            <MenuItem value="firstname">First Name</MenuItem>
            <MenuItem value="lastname">Last Name</MenuItem>
          </TextField>
          <Button
            color="primary"
            variant="contained"
            className="mr-2 px-3 min-w-120 min-h-40"
            onClick={() => onSearch(searchValue, searchField)}
          >
            <Icon className="mr-2">search</Icon>
            <span className="uppercase">Search</span>
          </Button>
          <Badge
            badgeContent={selectedConditions.length}
            color="primary"
            overlap="rectangular"
          >
            <Tooltip title="Filter by">
              <Button
                variant="outlined"
                color="primary"
                className={classes.filterBtn}
                onClick={() => setOpenFilter(true)}
              >
                <Icon className="text-primary mr-2">
                  filter_list
                </Icon>
                <span className="text-brand">Filter By</span>
              </Button>
            </Tooltip>
          </Badge>
        </div>
        {!!searchValue.length &&
          <FormHelperText className={classes.helperText}>
            <Typography variant="caption">
              Press &apos;Enter&apos; to search
            </Typography>
          </FormHelperText>
        }
      </div>
      <ViewColumn storageKey="depositTableCells" tableCells={tableCells} setHeadTableCells={setHeadTableCells} />
    </Toolbar>
  );
};

export default DepositsTableToolbar;
